import { BORDER_RADIUS } from "constants/variables";
import styled from "styled-components";

export const MapContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const StyledMap = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: ${BORDER_RADIUS.radius24};
`;
